<template>
  <div></div>
</template>

<script>

  export default {
    name: "Reports",
    components: {
    },
    data () {
      return {
      }
    },
    created() {     
    },
    mounted() {
    },
    methods: {
    },
    watch:
    {
    }

  }

</script>

<style scoped>

</style>
